/**
 * Javascript for list view of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 *
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */
var $           = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks    = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');
var basket      = require("./basket.js");
var translation = require("./translation.js");

/**
 * Global vars
 */
var srcJson                 = [];
var orgJson                 = [];
var translations            = {};
var activeFilter            = [];
var totalNumberOfProducts   = 0;
var activePage              = 0;
var numberOfPages           = 0;

/**
 * Global vars for view
 */
var numberOfShownProductsPerPage = 10;
var container = ".psr-shop-list";
var containerFilter = ".psr-shop-list-filter";

/**
 * Initialize the application
 */
if (window.srcJson) {
    orgJson = window.srcJson;
    showlist(orgJson, showVat);
    showfilter(orgJson);
    basket.showBasket();
}

/**
 * Generate the initial list and set global vars.
 */
function showlist(jsonOnPage) {
    // The JSON informations
    srcJson                 = jsonOnPage; // Get the JSON with the products
    totalNumberOfProducts   = srcJson.length; // Count the number of products

    // Page Inforamtion
    activePage              = 0;
    numberOfPages           = calcNumberOfPages();
    let active          = false

// Initialize Nunjucks
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

// Gernerate list view
    generateList(0);

// If more then 1 pages is required activate infinity scroll
    if (numberOfPages > 1) {
        $(window).on('scroll', function () {
            var scrollHeight = $(document).height();
            var scrollPosition = $(window).height() + $(window).scrollTop();
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 1) {
                infinityScroll();
            }
        });
    }

    $('.shop-basket-toggle').click(function () {
        if (!active) {
            $('.shop-basket-flyout').addClass('open');
            active = true
        }
        else {
            $('.shop-basket-flyout').removeClass('open');
            active = false
        }
    });

}

function showfilter(jsonOnPage) {
    // The JSON informations
    srcJson                 = jsonOnPage; // Get the JSON with the products
    totalNumberOfProducts   = srcJson.length; // Count the number of products)

    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

    var categories = new Map();
    srcJson.forEach(product => {
        product.categories.forEach(categorie => {
            categories.set(categorie.uid, categorie);
        });
    });

    let translations = {
        "filterAll": translation.getTranslation("filterAll"),
    };
    $(containerFilter).html(nunjucks.render('filter.twig', {translations: translations, categories: Array.from(categories)}));

    $('.btn.btn-filter').removeClass('active');
    $('.btn.btn-filter.all').addClass('active');

    $('.btn.btn-filter').click(function() {
        $(container).html('');

        var filterInput = $(this).data('category');

        if (filterInput === "all"){
            showlist(orgJson);
            $('.btn.btn-filter').removeClass('active');
            $('.btn.btn-filter.all').addClass('active');
            activeFilter = [];
        }
        else {
            $('.btn.btn-filter.all').removeClass('active');
            if (activeFilter.length > 0){
                if ($.inArray(filterInput, activeFilter) !== -1){
                    activeFilter.splice($.inArray(filterInput, activeFilter), 1);
                    $(this).removeClass('active');
                }
                else {
                    activeFilter.push(filterInput);
                    $(this).addClass('active');
                }
            }
            else {
                activeFilter.push(filterInput);
                $(this).addClass('active');
            }
            if (activeFilter.length > 0){
                showlist(findInArray(orgJson, activeFilter));
            }
            else {
                showlist(orgJson);
                $('.btn.btn-filter').removeClass('active');
                $('.btn.btn-filter.all').addClass('active');
            }
        }
    });
}

/**
 * Calculate the number of pages
 */
function calcNumberOfPages() {
    return Math.ceil(totalNumberOfProducts / numberOfShownProductsPerPage);
}

/**
 * Generate list of elemnts for the given page
 */
function generateList(page) {

    var products = [];

    var srcJsonCleaned = [];
    srcJson.forEach(snippet => {
        if (snippet.categories.length > 0) {
            srcJsonCleaned.push(snippet);
        }
    });

    // Check if it is the first page (page = 0)
    if (page == 0) {
        products = srcJsonCleaned.slice(0, numberOfShownProductsPerPage); // Get the first number of elements
    }
    else {
        products = srcJsonCleaned.slice(page * numberOfShownProductsPerPage, page * numberOfShownProductsPerPage + numberOfShownProductsPerPage); // Get the next number of elements
    }
    products.forEach(product => {
        var productView = generateSingleItem(product);
        $(container).append(productView);
    });

    $('.order-button').click(function() {
        basket.order($(this).data('product'), 1, $(this).data('uid'));
        var btn = $(this);
        $(btn).after('<p class="basket-message">' + translation.getTranslation('product-added-to-filter') + '</p>');
        var temp = $('p.basket-message', $(btn).parent());
        $(temp).hide().fadeIn('200');
        setTimeout(function () {
            $(temp).fadeOut('200', function(){ $(temp).remove(); });
        }, 5000);
    });
}

function generateSingleItem(product) {

    translations = {
        'sum-total': translation.getTranslation("sum-total"),
        'price': translation.getTranslation("price"),
        'quantity': translation.getTranslation("quantity"),
        'checkout': translation.getTranslation("checkout"),
        'back': translation.getTranslation("back"),
        'remove': translation.getTranslation("remove"),
        'basket': translation.getTranslation("basket"),
        'highlights': translation.getTranslation("highlights"),
        'order': translation.getTranslation("order"),
        'intobasket': translation.getTranslation("into-basket"),
        'description': translation.getTranslation("description"),
        'baskethelp': translation.getTranslation("basket-help"),
        'readmore': translation.getTranslation("readmore"),
        'vat': translation.getTranslation("vat")
    };

    product.description = encodeURI(product.description);

    // return nunjucks.render('list-item.twig', {translations: translations, product: product, uid: product.uid, title: product.title, price: translation.currencyFormatter(product.price), available: product.available, images: product.images, uri: product.uri});
    var displayPrice = product.price.toFixed(2);
    var showVat = window.showVat;
    return nunjucks.render('list-item.twig', {currency: currency,translations: translations, product: product, uid: product.uid, title: product.title, price: displayPrice, available: product.available, images: product.images, uri: product.uri, showVat: showVat});
}

/**
 * Infinity Scroll
 */
function infinityScroll() {
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});
    if (activePage != numberOfPages) {
        activePage += 1;
        generateList(activePage);
    }
}

/**./stop
 *
 * @param contentElements
 * @param swordArray
 * @returns {*}
 */
function findInArray (contentElements,swordArray) {
    var categoryUidList = [];
    $.each(swordArray, function(key, sword){
        categoryUidList.push(sword.uid);
    });
    var filteredByCategory = [];
    $.each(contentElements, function(key, element){
        $.each(element.categories, function(key, category){
            if ($.inArray(category.uid, categoryUidList) !== -1){
                filteredByCategory.push(element);
            }
        });
    });
    var intermArray = [];
    $.each(filteredByCategory, function (key, product) {
        if ($.inArray(product, intermArray) < 0 ){
            intermArray.push(product);
        }
    });
    return intermArray;
}

/**
 *
 * @param contentElements
 * @param sword
 * @returns {*}
 */
function findInSubArray (contentElements,sword) {
    for (var k in contentElements){
        if (typeof contentElements[k] == 'object') {
            match = findInSubArray(contentElements[k],sword);
        } else {
            match = JSON.stringify(contentElements[k]).indexOf(sword);

        }
        if(match > -1 || match === true) {
            return match
        }
    }
}
